
<template>
  <div>
    <ul class="tabs_box" style="padding: 0">
      <li
        class="tabs_box-item"
        v-for="tab in props.list"
        :class="state.activeType === tab.type ? 'active_tab' : null"
        :key="tab.type"
        @click="handleChoose(tab)"
      >
        <img
          :src="tab.activeIcon"
          class="tabs_box-item-icon"
          v-if="state.activeType === tab.type"
        />
        <img :src="tab.icon" class="tabs_box-item-icon" v-else />
        <el-badge :value="tab.count" :hidden="tab.count <= 0" :max="99">
          <span>{{ tab.name }}</span>
        </el-badge>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { reactive, watch, onMounted } from "vue"

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: "",
  },
  list: {
    type: Array,
    default: () => [],
  },
})
const emits = defineEmits(["choose", "update:modelValue"])
const state = reactive({
  activeType: "1",
})

const handleChoose = tab => {
  if (state.activeType === tab.type) return
  state.activeType = tab.type
  emits("update:modelValue", state.activeType)
  emits("choose", state.activeType)
}

watch(
  () => props.modelValue,
  val => {
    state.activeType = val
  }
)

onMounted(() => {
  state.activeType = props.modelValue
})
</script>

<style scoped lang="less">
.el-badge {
  padding-right: 8px;
}
</style>
